// extracted by mini-css-extract-plugin
export default {"tooltip":"En-z","sharingV2":"Fn-z","sharingIconsV2":"Gn-z","links":"Hn-z","link":"In-z","facebookV2":"Jn-z","twitterV2":"Kn-z","pinterestV2":"Ln-z"};